import React from 'react';

import Button from '../Button';

import {useTranslation} from 'react-i18next';

import styles from './SignOutForm.module.css';

interface SignOutFormProps {
  userName: string,

  onLogOut(): void
  onGoNext(): void
}


const SignOutForm = (props: SignOutFormProps) => {
  const {t} = useTranslation();

  return (
    <>
      <div className={styles.signInAs}>
        <span>{`${t('youSignInAs')} `}</span>
        <strong style={{whiteSpace: 'nowrap'}}>{props.userName}</strong>
      </div>
      <div
        className={styles.fakeLink}
        onClick={props.onLogOut}
      >
        {`${t('notThisAccount')}? ${t('signOut')}`}
      </div>
      <Button
        className={styles.button}
        onClick={props.onGoNext}
      >
        {t('goToPackage')}
      </Button>
    </>
  );
};

export default SignOutForm;
